import { useRouter } from 'next/navigation'
import { forwardRef } from 'react'

import { LocationLevel } from '@/utils/tracker/shared'
import { DataIndukVariant } from '@/apis/types'

import { UncontrolledSearchBox } from '@/components/CommonSearchBox/UncontrolledSearchBox'

import { PREFIX_BY_VARIANT, VARIANT } from '../constant'

export interface DataIndukSearchBoxProps {
  source: string
  initialValue?: string
  locationId: string
  locationLevel: LocationLevel
  variant?: DataIndukVariant
  placeholder?: string
  onSubmit?: (keyword: string) => void
}

type Ref = HTMLFormElement

export const DataIndukSearchBox = forwardRef<Ref, DataIndukSearchBoxProps>(
  function Component(
    {
      source,
      initialValue,
      onSubmit,
      locationId,
      locationLevel,
      placeholder = `Cari Data: “SD Merdeka Belajar” atau “Jakarta”`,
      variant = VARIANT.SATPEN,
    },
    ref
  ) {
    const router = useRouter()

    const handleSubmit = (safeKeyword: string) => {
      if (typeof onSubmit === 'function') {
        onSubmit?.(safeKeyword)
      } else {
        const prefixPath = PREFIX_BY_VARIANT[variant] as string
        router.push(
          `${prefixPath}/search?s=${safeKeyword}&offset=0&lid=${locationId}&ll=${locationLevel}&fr=${encodeURIComponent(
            source
          )}#search-section`
        )
      }
    }

    return (
      <UncontrolledSearchBox
        data-variant={variant}
        onSubmit={handleSubmit}
        ref={ref}
        initialValue={initialValue}
        placeholder={placeholder}
      />
    )
  }
)
